import { useEffect, useRef, useState } from 'react';

/**
 * Auto-growing bio field. Tapping it opens a focused editor (just the text and
 * a Done button, like composing a caption); Done hands the text back and the
 * owner's auto-save persists it.
 */
export function BioEditor({ value, onChange, maxLength = 500 }: { value: string; onChange: (v: string) => void; maxLength?: number }) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(value);
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => { if (open) { setDraft(value); setTimeout(() => { ref.current?.focus(); autosize(ref.current); }, 0); } }, [open, value]);
  const autosize = (el: HTMLTextAreaElement | null) => { if (!el) return; el.style.height = 'auto'; el.style.height = `${el.scrollHeight}px`; };

  if (!open) {
    return (
      <button type="button" className="bio-preview" onClick={() => setOpen(true)}>
        {value ? <span>{value}</span> : <span className="muted">Write a short bio…</span>}
      </button>
    );
  }
  const done = () => { onChange(draft.trim()); setOpen(false); };
  return (
    <div className="bio-editor" role="dialog" aria-modal="true">
      <div className="bio-editor-top">
        <button className="btn ghost" onClick={() => setOpen(false)}>Cancel</button>
        <strong>Bio</strong>
        <button className="btn sm" onClick={done}>Done</button>
      </div>
      <textarea ref={ref} value={draft} maxLength={maxLength} placeholder="What are you looking for? What do you play?" onChange={(e) => { setDraft(e.target.value); autosize(e.target); }} />
      <div className="muted small" style={{ textAlign: 'right' }}>{draft.length}/{maxLength}</div>
    </div>
  );
}
